(function () {
  'use strict';
  if (window.DaLucaCustomMasterV357) return;
  window.DaLucaCustomMasterV357 = true;

  function root() {
    return document.querySelector('.daluca-pdp--custom[data-daluca-custom-master]');
  }

  function setImp(el, prop, value) {
    if (el) el.style.setProperty(prop, value, 'important');
  }

  function centerBuckles() {
    document.querySelectorAll('.daluca-custom-builder-live--consolidated .daluca-proxy-field[data-daluca-proxy-field^="Buckle"]').forEach(function (field) {
      var grid = field.querySelector('.daluca-proxy-choice-grid');
      if (!grid) return;
      setImp(grid, 'display', 'flex');
      setImp(grid, 'flex-wrap', 'wrap');
      setImp(grid, 'justify-content', 'center');
      setImp(grid, 'align-items', 'stretch');
      setImp(grid, 'gap', '8px');
      Array.from(grid.children).forEach(function (card) {
        setImp(card, 'display', 'flex');
        setImp(card, 'flex-direction', 'column');
        setImp(card, 'align-items', 'center');
        setImp(card, 'justify-content', 'center');
        setImp(card, 'text-align', 'center');
        if (window.innerWidth >= 1181) {
          setImp(card, 'flex', '0 0 calc((100% - 24px) / 4)');
          setImp(card, 'max-width', 'calc((100% - 24px) / 4)');
        }
        var img = card.querySelector('img,picture,svg');
        if (img) {
          setImp(img, 'display', 'block');
          setImp(img, 'margin-left', 'auto');
          setImp(img, 'margin-right', 'auto');
          setImp(img, 'align-self', 'center');
          setImp(img, 'object-position', 'center center');
        }
        var text = card.querySelector('.daluca-proxy-choice__text');
        if (text) {
          setImp(text, 'width', '100%');
          setImp(text, 'text-align', 'center');
        }
      });
    });
  }

  function keeperSvg(two) {
    var loop2 = two ? '<rect x="130" y="17" width="32" height="54" rx="6" fill="#c89c60" stroke="#80613b" stroke-width="3"/><path d="M135 26h22M135 62h22" stroke="#efe2ca" stroke-width="1.5" stroke-dasharray="2 3"/>' : '';
    var title = two ? '2 keepers' : '1 keeper';
    return '<svg viewBox="0 0 240 84" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="'+title+'">' +
      '<rect x="14" y="31" width="212" height="26" rx="12" fill="#b98249" stroke="#80572f" stroke-width="2"/>' +
      '<path d="M25 38h190M25 50h190" stroke="#ead6b9" stroke-width="1.6" stroke-dasharray="3 5" opacity=".9"/>' +
      '<rect x="92" y="17" width="32" height="54" rx="6" fill="#c89c60" stroke="#80613b" stroke-width="3"/>' +
      '<path d="M97 26h22M97 62h22" stroke="#efe2ca" stroke-width="1.5" stroke-dasharray="2 3"/>' + loop2 +
      '</svg>';
  }

  function rebuildKeepers() {
    var visualizer = document.querySelector('[data-daluca-visualizer]');
    if (visualizer && /military|nato|single.?piece/i.test(visualizer.dataset.family || visualizer.dataset.productHandle || '')) return;
    document.querySelectorAll('.daluca-custom-builder-live--consolidated .daluca-proxy-field[data-daluca-proxy-field="Keeper"] .daluca-proxy-choice').forEach(function (button, index) {
      var currentText = button.querySelector('.daluca-proxy-choice__text');
      var label = (currentText ? window.DaLucaI18n.sourceText(currentText) : window.DaLucaI18n.sourceText(button) || '').trim();
      var two = /2\s*keeper|two\s*keeper/i.test(label) || index === 1;
      var cleanLabel = label || (two ? '2 Keepers' : '1 Keeper');
      if (button.querySelector('.daluca-keeper-visual-v357') && button.dataset.dalucaKeeperV357 === '1') return;
      // Keep the button itself and its original click listener, replace only its content.
      window.DaLucaI18n.setHtml(button, '');
      var visual = document.createElement('div');
      visual.className = 'daluca-keeper-visual-v357';
      visual.setAttribute('aria-hidden', 'true');
      window.DaLucaI18n.setHtml(visual, keeperSvg(two));
      var text = document.createElement('span');
      text.className = 'daluca-proxy-choice__text';
      window.DaLucaI18n.setText(text, cleanLabel);
      button.appendChild(visual);
      button.appendChild(text);
      button.title = cleanLabel;
      button.setAttribute('aria-label', cleanLabel);
      button.dataset.dalucaKeeperV357 = '1';
    });
  }

  function rebuildNativeKeepers() {
    var visualizer = document.querySelector('[data-daluca-visualizer]');
    if (!visualizer || visualizer.dataset.family !== 'two-piece') return;
    document.querySelectorAll('.gpo-element input[name^="Keeper"], .gpo-element input[name="properties[Keeper]"]').forEach(function(input) {
      var item = input.closest('.gpo-ov-item') || input.closest('label');
      if (!item) return;
      var two = /2|two/i.test(input.value || '');
      var src = 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(keeperSvg(two));
      item.querySelectorAll('img').forEach(function(img) {
        if (img.getAttribute('src') === src) return;
        img.removeAttribute('srcset'); img.setAttribute('src',src);
        img.setAttribute('data-daluca-brown-keeper','true');
      });
    });
  }

  function alignBuilder() {
    var fit = document.querySelector('.daluca-custom-builder-live--consolidated .daluca-builder-section--fit');
    if (fit) {
      ['Lug Width','Taper'].forEach(function (name) {
        var h = fit.querySelector('.daluca-proxy-field[data-daluca-proxy-field="'+name+'"] .daluca-proxy-field__heading');
        if (h && window.innerWidth >= 1181) {
          setImp(h,'height','74px');
          setImp(h,'min-height','74px');
        } else if(h) {
          h.style.removeProperty('height');
          h.style.removeProperty('min-height');
        }
      });
    }
    var edge = document.querySelector('.daluca-custom-builder-live--consolidated .daluca-proxy-field[data-daluca-proxy-field="Edge Coating"] .daluca-proxy-choice-grid, .daluca-custom-builder-live--consolidated .daluca-proxy-field[data-daluca-proxy-field="Edge Finish"] .daluca-proxy-choice-grid');
    if (edge && window.innerWidth >= 1181) {
      setImp(edge,'display','grid');
      setImp(edge,'grid-template-columns','repeat(auto-fill,minmax(56px,1fr))');
    }
  }

  function restoreProcess() {
    var guide = document.querySelector('.daluca-custom-order-guide--master.daluca-custom-order-guide--rollout');
    if (!guide) return;
    guide.hidden = false;
    guide.removeAttribute('aria-hidden');
    setImp(guide,'display','block');
    setImp(guide,'visibility','visible');
    setImp(guide,'opacity','1');
    if (!document.querySelector('.daluca-process-panel-v32') && typeof window.__dalucaInitProcessGuideV32 === 'function') {
      delete guide.dataset.dalucaProcessV32;
      window.__dalucaInitProcessGuideV32();
    }
    var panel = document.querySelector('.daluca-process-panel-v32');
    if (panel) {
      panel.removeAttribute('hidden');
      panel.removeAttribute('aria-hidden');
      setImp(panel,'display','block');
    }
  }

  function run() {
    if (!root()) return;
    centerBuckles();
    rebuildKeepers();
    rebuildNativeKeepers();
    alignBuilder();
    restoreProcess();
  }

  var timer = 0;
  function queue() {
    clearTimeout(timer);
    timer = setTimeout(run, 55);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once:true });
  else run();
  if (document.body) new MutationObserver(queue).observe(document.body,{childList:true,subtree:true});
  window.addEventListener('resize', queue, { passive:true });
  document.addEventListener('shopify:section:load', queue);
  [100,300,700,1400,2800].forEach(function (d) { setTimeout(run,d); });
})();


